module.exports = __webpack_public_path__ + "media/src/images/logos/partners/niti-6ac8493e9f163834037463af883e235f.png";